import React from "react";
export const GenericFormContext = React.createContext({});
